import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaDescontoCupomMatricula = (): TabelaColuna => ({
  Chave: 'DescontoCupomMatricula',
  ComOrdenacao: true,
  RenderizarCabecalho: () => (
    <div style={{ width: 250 }}>Desconto Cupom Matrícula</div>
  )
})
